function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0,147.3V0h65.7c28,0,42.4,17.9,42.4,37.5c0,18.3-11.5,30.9-25.4,33.8c15.9,2.4,28.3,17.7,28.3,36   c0,22.3-14.6,40-42.8,40H0z M76.1,43.1c0-9.1-6.6-15.5-17.2-15.5H31.4v30.9h27.5C69.5,58.5,76.1,52.6,76.1,43.1z M79,102.9   c0-9.3-6.6-16.8-18.8-16.8H31.4v33.6h28.9C71.9,119.7,79,113.5,79,102.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.6,104.6v-64h28.2v63.1c0,12.7,7.7,21.9,22.7,21.9c14.8,0,22.6-9.2,22.6-21.9V40.6h28.1v63.9   c0,26.8-16.1,45.6-50.6,45.6C136.1,150.1,119.6,131.1,119.6,104.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M230.5,147.3v-21l48.1-61.2h-48.1V40.6h86.3v20.1l-49,62.1h49.9v24.5H230.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M326.9,147.3v-21L375,65.1h-48.1V40.6h86.3v20.1l-49,62.1h49.9v24.5H326.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M424.6,147.3V0h102.2v27.6H456v30.9h53.3v27.6H456v61.2H424.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M517.2,93.9c0-30.9,23-55.9,55.2-55.9c32,0,53.4,23.9,53.4,58.5v6.6h-79.3c2,13,12.6,23.9,30.7,23.9   c9.1,0,21.4-3.8,28.3-10.4l12.6,18.6c-10.6,9.7-27.4,14.8-43.9,14.8C541.7,150,517.2,128.1,517.2,93.9z M572.4,61   c-17.4,0-25,12.1-26.1,22.7h52.6C598,73.5,590.9,61,572.4,61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M633.4,93.9c0-30.9,23-55.9,55.2-55.9c32,0,53.4,23.9,53.4,58.5v6.6h-79.3c2,13,12.6,23.9,30.7,23.9   c9.1,0,21.4-3.8,28.3-10.4l12.6,18.6c-10.6,9.7-27.4,14.8-43.9,14.8C657.9,150,633.4,128.1,633.4,93.9z M688.6,61   c-17.4,0-25,12.1-26.1,22.7h52.6C714.2,73.5,707.1,61,688.6,61z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M752.3,147.5V40.4h43c33.7,0,58,20.2,58,53.5c0,33.2-24.2,53.6-57.8,53.6H752.3z M826,93.9   c0-16.6-10-30.4-29.6-30.4H779v60.9h17.4C815.1,124.4,826,109.8,826,93.9z"
}));

var SvgBuzzFeedLogo = function SvgBuzzFeedLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 853.3 150.1",
    style: {
      enableBackground: "new 0 0 853.3 150.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuzzFeedLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BuzzFeed-Logo.2c05afea.svg";
export { ForwardRef as ReactComponent };